import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { ResponseAggregatesRpc } from "../../lib/discordTypes";

type Props = {
  data: ResponseAggregatesRpc[];
};

export default function MultipleSelectCard({ data }: Props) {
  const question = data[0].question;
  const totalResponses = data[0].step_responses;

  return (
    <div
      className="p-5 flex flex-col items-center overflow-hidden rounded-lg border border-gray-100 flex-1"
      style={{ maxWidth: "500px" }}
    >
      <p className="m-0 text-left w-full">{question}</p>
      <p className="text-left w-full text-xs font-light">
        {totalResponses} responses
      </p>
      <BarChart width={300} height={210} data={data} className="-ml-6 mt-2">
        <CartesianGrid strokeDasharray="1 1" />
        <XAxis dataKey="answer" />
        <YAxis />
        <Tooltip />
        <Bar dataKey="count" fill="#0088FE" />
      </BarChart>
    </div>
  );
}
